import MediaPlanGallery from './MediaPlanGallery';

export default MediaPlanGallery;
